import cs from "classnames";
import PropTypes from "prop-types";
import styles from "./loading-spinner-anything.module.scss";

const LoadingSpinnerAnything = ({ color, children, isLoading, className }) => {
  const { wrapper = "", backdrop = "", loadingIcon = "" } = className || {};
  return (
    <div className={cs(styles.wrapper, wrapper)}>
      {children}
      {isLoading && (
        <>
          <div
            data-testid="backdrop"
            className={cs(styles.backdrop, backdrop, {
              [styles.hide]: !isLoading
            })}
          />
          <LoadingIndicator
            data-testid="loadingIcon"
            color={color}
            className={cs(styles.loadingIcon, loadingIcon, {
              [styles.hide]: !isLoading
            })}
          />
        </>
      )}
    </div>
  );
};

import { LoadingIndicator } from "@lululemon/ecom-site-utils/src/externals/pattern-library/ui-library";

LoadingSpinnerAnything.defaultProps = {
  color: "red",
  isLoading: false
};

LoadingSpinnerAnything.propTypes = {
  color: PropTypes.oneOf(["red", "gray"]),
  children: PropTypes.node,
  isLoading: PropTypes.bool,
  className: PropTypes.shape({})
};

export default LoadingSpinnerAnything;
